import { render, staticRenderFns } from "./prebuild-sticky-banner.vue?vue&type=template&id=3c9bf35d&scoped=true&"
import script from "./prebuild-sticky-banner.vue?vue&type=script&lang=js&"
export * from "./prebuild-sticky-banner.vue?vue&type=script&lang=js&"
import style0 from "./prebuild-sticky-banner.vue?vue&type=style&index=0&id=3c9bf35d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9bf35d",
  null
  
)

export default component.exports